// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"43":"referrals","389":"404","943":"root"}[chunkId] + "." + {"43":"cbb55b15","389":"4fe0bd47","943":"287402dd"}[chunkId] + ".css";
};